// extracted by mini-css-extract-plugin
export default {"box":"Progress_box__EJqKY","progress":"Progress_progress__8-j2V"};